import { AvBillingInfoNanoID } from './avBillingInfosTypes';

const origin = typeof window === 'undefined' ? '' : window.location.origin;

export class AvBillingInfoPublicUrl {
  static logo(avBillingInfoNanoId: AvBillingInfoNanoID) {
    return `${origin}/images/abi/${avBillingInfoNanoId}.png`;
  }
}
